<div class="load-more-container" *ngIf="max > 1">
  
  <button class="btn-load-more" 
          (click)="loadMore()" 
          *ngIf="!isEnd() && !isChanging">
    <span>Voir plus</span>
    <i class="fa-solid fa-chevron-down"></i>
  </button>

  <div class="loading-dots" *ngIf="isChanging">
    <span></span><span></span><span></span>
  </div>

  <div class="end-message" *ngIf="isEnd()">
    <div class="line"></div>
    <span>Vous êtes arrivé à la fin...</span>
    <div class="line"></div>
  </div>

</div>